import { setToken, getToken, curlHttp, setStore, getStore } from '@/library/utils'
import api from '../../library/api.service'

export default {
  state: {
    currentflow: 1,
    taskFlow: [] || getStore('taskflow'),
    taskStepsDetail: {},
    setCurrStepsDetail: [],
    taskdoneratio: [],
    typesratio: [],
    taskdelayrate: 0,
    tagslistrate:[],
    taskdata: [],
  },
  mutations: {
    setCurrentTask (state, value) {
      state.currentflow = value
    },
    setTaskFlow (state, value) {
      state.taskFlow = value
      setStore('taskflow', '')
      setStore('taskflow', value)
    },
    setStepsDetail (state, value) {
      state.taskStepsDetail = value
    },
    setCurrStepsDetail (state, value) {
      state.setCurrStepsDetail = value
    },
    setTaskDoneRatio (state, value) {
      state.taskdoneratio = value
    },
    setTypesRatio (state, value) {
      state.typesratio = value
    },
    setDelayRate (state, value) {
      state.taskdelayrate = value
    },
    setTagsListRate (state, value){
      state.tagslistrate = value
    },
    setTaskData (state, value) {
      state.taskdata = value
    }
  },
  actions: {
    getSourceTask({state, commit}, { current_page, page_size, formSearch }) {
      return new Promise((resolve, reject) => {
        let params = {
          current_page: current_page,
          page_size: page_size,
          ...formSearch
        }
        let urls = api.api.task.bypage
        curlHttp(urls.url, {}, urls.method).then(res => { 
          if (res.code === 200 ) {
            commit('setTaskData', res.detail)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    handleTaskDetail({ commit }, value) {
      return new Promise((resolve, reject) => {
        let urls = api.api.taskflow.detail
        curlHttp(urls.url+value+'/', {}, urls.method).then(res => {
          if (res.code === 200) {
            commit('setStepsDetail', res.detail)
          }
        })
      })
    },
    handleTaskData({ commit }) {
      return new Promise((resolve, reject) => {
        let urls = api.api.taskflow.bypage
        curlHttp(urls.url, {}, urls.method).then(res => {
          if (res.code === 200) {
            commit('setTaskFlow', res.detail)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    handleTaskFlowSteps({state, commit}, flowid){
      return new Promise((resolve, reject) => {
        let taskflow = JSON.parse(getStore('taskflow')) || state.taskFlow
        
        if(flowid) {
          let stepslist = taskflow.filter(item => item.id == flowid)
          commit('setCurrStepsDetail', stepslist[0].steps)
        }else{
          let stepslist = taskflow.filter(items => items.id === state.currentflow)
          commit('setCurrStepsDetail', stepslist[0].steps)
        }
      })
    },
    //任务完成率
    handleTaskDoneRatio({state, commit}, { project }) {
      return new Promise((resolve, reject) => {
        if(!project) return
        let params = {
          project: project
        }
        let urls = api.api.project.done
        curlHttp(urls.url, params, urls.method).then(res => {
          if (res.code == 200 ) {
            commit('setTaskDoneRatio', res.detail)
            resolve(res.detail)
          }
        }).catch(err => {
          reject(err)
          if (err) {
            this.$Notice.error({
              title: '错误警告',
              desc: '发生错误'
            });
          }
        })
      })
    },
    //任务类型占比
    handleTypesRatio({state, commit}, { project }) {
      return new Promise((resolve, reject) => {
        if(!project) return
        let params = {
          project: project
        }
        let urls = api.api.task.tagsratio
        curlHttp(urls.url, params, urls.method).then(res => {
          if (res.code == 200 ) {
            commit('setTypesRatio', res.detail)
            resolve(res.detail)
          }
        }).catch(err => {
          reject(err)
          if (err) {
            this.$Notice.error({
              title: '错误警告',
              desc: '发生错误'
            });
          }
        })
      })
    },
    //
    handleDelayRate({state, commit}, { project }) {
      return new Promise((resolve, reject) => {
        if(!project) return
        let params = {
          project: project
        }
        let urls = api.api.task.delay
        curlHttp(urls.url, params, urls.method).then(res => {
          if (res.code == 200 ) {
            commit('setDelayRate', res.detail)
            resolve(res.detail)
          }
        }).catch(err => {
          reject(err)
          if (err) {
            this.$Notice.error({
              title: '错误警告',
              desc: '发生错误'
            });
          }
        })
      })
    },
    handleTagsList({state, commit}, { project }) {
      return new Promise((resolve, reject) => {
        if(!project) return
        let params = {
          project: project
        }
        let urls = api.api.task.tagslist
        curlHttp(urls.url, params, urls.method).then(res => {
          if (res.code == 200 ) {
            commit('setTagsListRate', res.detail)
            resolve(res.detail)
          }
        }).catch(err => {
          reject(err)
          if (err) {
            this.$Notice.error({
              title: '错误警告',
              desc: '发生错误'
            });
          }
        })
      })
    },
    

    
  



  }
}